import { useTranslation } from 'react-i18next'

function Banner() {
  const { t } = useTranslation()

  return (
    <section className="w-full bg-sage py-40 px-20 tablet:px-32">
      <div className="max-w-lg mx-auto">
        <p className="text-lato-italic text-white text-center text-3xl leading-relaxed">
          {t('pages.home.sections.banner.text')}
        </p>
      </div>
    </section>
  )
}

export default Banner
